module.exports = __webpack_public_path__ + "img/not-found-folder-file.9292cf63.svg";